import NoLoginLayout from "@/components/layout/admin/NoLoginLayout.vue";
import {
    required,
    email
} from "vuelidate/lib/validators";
import axios from "axios";

export default {
    name: "forgetPassword",
    components: {
        NoLoginLayout
    },

    data() {
        return {
            email: "",
            submitted: false
        };
    },

    validations: {
        email: {
            required,
            email
        }
    },

    methods: {
        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.sendResetMail();
        },

        sendResetMail() {
            var request = {
                email: this.email
            };
            axios.post("/admin/forget_password", request)
                .then(response => {
                    console.log("API Success", response.data);
                    if (response.data.msg) {
                        this.$notification.error(response.data.msg, {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                    } else {
                        this.$notification.success('Reset Mail was sent successfully', {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                        this.$router.push({ name: 'adminLogin' });
                    }
                })
                .catch(error => {
                    this.$notification.error("Error occur while sending reset mail!!!", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    console.log("Mail Send Error", error);
                });
        }
    }
};